import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconChevronDown: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3.40007 5.4L7.40007 9.4L11.4001 5.4"
    />
  </svg>
);

export {
  IconChevronDown,
};
